import React from 'react';
import getComponentClassNames from '../../utils/className/getComponentClassNames';
import { Image } from '../../components/Image';
import { BlockLink, MaskedLink } from '../../components/Link';
import HeartIcon from '../../components/Image/HeartIcon';
import type { TLinkBase } from '../../components/Link/LinkBase';
import { Box } from '../../components/Box';

const classNames = getComponentClassNames(['StructuredListing', { modifiers: 'vertical' }], ['body', 'title']);

type TStructuredListingProps = {
  title: string;
  price: string;
  imageSrc?: string;
  imageLoading?: 'lazy' | 'eager' | undefined;
  decoding?: 'sync' | 'async' | 'auto' | undefined;
  currency?: string;
  imageOverlayLabel?: string;
  className?: string;
  alt?: string;
  onError?: () => void;
  isMaskedLink?: boolean;
  onClick?: () => void;
  onContextMenu?: () => void;
  onHeart?: () => void;
  isFavorite?: boolean;
  showFav?: boolean;
  favAriaLabel?: string;
  linkProps?: TLinkBase & { href: string } & Record<string, any>;
};

const StructuredListing = ({
  title,
  price,
  imageSrc = '',
  imageLoading,
  decoding,
  currency = '',
  isMaskedLink = false,
  onHeart,
  isFavorite = false,
  favAriaLabel = '',
  showFav = false,
  alt = 'image',
  className,
  linkProps = { href: '#' },
}: TStructuredListingProps) => {
  const LinkComponent = isMaskedLink ? MaskedLink : BlockLink;

  return (
    <Box as="article" name="StructuredListing" modifiers="vertical" className={className}>
      <LinkComponent {...linkProps}>
        <Image
          loading={imageLoading}
          decoding={decoding}
          src={imageSrc}
          alt={alt}
          fetchpriority="high"
          aspectRatio="landscape"
        />
        <div className={classNames.body}>
          <span className={classNames.title}>{title}</span>
          <div className="hz-Title hz-Title--title5">
            {currency && `${currency} `}
            {price}
          </div>
        </div>
      </LinkComponent>
      {showFav ? (
        <HeartIcon onClick={onHeart} isFavorite={isFavorite} tabIndex="0" alwaysVisible ariaLabel={favAriaLabel} />
      ) : null}
    </Box>
  );
};

export default StructuredListing;
